import { Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { QuizComponent } from '../../../generate-content-pane/components/quiz/quiz.component';
import { Chunk } from '../../chunk.dto';

interface QuizData {
  title: string;
  questions: any[];
}

@Component({
  selector: 'app-quiz-chunk-displayer',
  template: `
    @if (quizData()) {
      <div class="quiz-chunk-container">
        <app-quiz [data]="quizData()" [isChunkMode]="true"></app-quiz>
      </div>
    }
  `,
  styles: [
    `
      .quiz-chunk-container {
        width: 100%;
        margin: 1rem 0;
      }
    `,
  ],
  standalone: true,
  imports: [QuizComponent],
})
export class QuizChunkDisplayerComponent {
  chunk = input.required<Chunk>();
  private translate = inject(TranslateService);

  quizData = computed(() => {
    const chunk = this.chunk();
    if (!chunk || !chunk.editions) return null;

    // Try to find edition for current language
    const currentLang = this.translate.currentLang;
    const edition = chunk.editions.find((e) => e.language === currentLang) || chunk.editions[0];

    if (!edition || !edition.content) return null;

    try {
      // In chunk editions, content is stored as stringified JSON (or just JSON object if not stringified by backend yet)
      const parsed = typeof edition.content === 'string' ? JSON.parse(edition.content) : edition.content;

      // Unwrap if the content is wrapped in { type: 'quiz', content: ... }
      if (parsed && parsed.type === 'quiz' && parsed.content) {
        return parsed.content;
      }

      return parsed;
    } catch (e) {
      console.error('Failed to parse quiz chunk content', e);
      return null;
    }
  });
}
